import { StyleSheet } from 'react-native'
import Identity from '../../utils/Identity'

const useFiltersContaientStyles = (theme, isTablet) => StyleSheet.create({
  filters: {
    width: '100%',
    marginVertical: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: isTablet ? 'flex-start' : 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20
  },
  largeFilters: {
    paddingTop: 30,
    paddingHorizontal: 25,
    paddingBottom: 10,
    marginTop: 0,
    borderRadius: 10,
    backgroundColor: theme.CARD_BACKGROUND,
    ...Identity.Shadow(theme).Card
  },
  firstSection: {
    width: '100%',
    marginBottom: !isTablet ? 20 : 0
  },
  buttons: {
    height: isTablet ? '100%' : 'auto',
    width: isTablet ? 'auto' : '100%',
    flexDirection: 'row',
    marginTop: 5
  },
  inputs: {
    flexDirection: 'row'
  },
  input: {
    flex: 1
  },
  inputTablet: {
    marginRight: 15
  },
  firstSectionDesk: {
    flex: 1
  },
  title: {
    fontWeight: 'bold',
    marginBottom: 10,
    fontSize: 13
  },
  options: {
    width: 'auto',
    height: 30,
    borderRadius: 100,
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingLeft: 20
  }
})

const filtersStyles = StyleSheet.create({
  inputsContainer: {
    flexDirection: 'row'
  },
  input: {
    flex: 1
  },
  inputTablet: {
    marginRight: 15
  },
  dateLabel: {
    position: 'absolute',
    top: -15
  }
})

export {
  useFiltersContaientStyles,
  filtersStyles
}
